<template>
  <router-view></router-view>
</template>

<script setup>
import { ref, reactive,  provide, onBeforeMount, onMounted,inject,watchEffect } from 'vue'
// const code = inject('auth_code')
//动态获取接口地址
import { gettoken,getmy } from '@/assets/js/common.js'
const _url2 = inject('_url2')
const _url = inject('_url')


onMounted(() => {
        
})
   
</script>
